export const FAQ_BASE_URL = 'https://www.promptcrew.io/faq';

export const FAQ_LINKS = {
  assistant: `${FAQ_BASE_URL}#assistant`,
  builder: `${FAQ_BASE_URL}#builder`,
  capabilities: `${FAQ_BASE_URL}#library`,
  knowledge: `${FAQ_BASE_URL}#knowledge`,
  projects: `${FAQ_BASE_URL}#projects`,
  community: `${FAQ_BASE_URL}#community`,
};

export const openFaq = (url) => {
  if (typeof window === 'undefined') return;
  window.open(url || FAQ_BASE_URL, '_blank', 'noopener,noreferrer');
};
